import Dummy from '@/views/Dummy';

export default {
  name: 'MedicalRecords',
  components: {
    Dummy
  }
};
